// extracted by mini-css-extract-plugin
module.exports = {"recommandContent":"RecommandArea_recommandContent__xR4iW","stickyIcon":"RecommandArea_stickyIcon__XW7jM"};